// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

const XBeforeLoadProducts = (props: any) => {
    const {
        parameter: { numberOfProductsToDisplay, carouselType, productNumbers },
    } = props;
    // make sure that when we have max number of products to display we need to fetch them
    // Add product numbers incase we have featured carousel
    props.getProductCollectionParameter = {
        ...props.getProductCollectionParameter,
        ...(carouselType === "featuredProducts" && { productNumbers }),
        ...(!!numberOfProductsToDisplay && { pageSize: numberOfProductsToDisplay }),
        expand: [...(props.getProductCollectionParameter?.expand || []), "properties"],
    };
};

addToChainBefore(chain, LoadProducts, XBeforeLoadProducts);
